<template>
  <main>
    <form-dialog
      v-model="isActive"
      max-width="800px"
      :sending="sendingToMagazzino"
      @confirm="onConfirm">

      <template slot="title">
        <span>{{ $t('magazzino.label.carrello') }}</span>

        <v-tooltip bottom>
          <v-btn flat icon slot="activator">
            <v-icon>help_outline</v-icon>
          </v-btn>
          <span class="text-pre-line">{{ $t('magazzino.label.info_carrello') }}</span>
        </v-tooltip>

        <form ref="shopLinkForm" method="POST" :action="fgShopAddToCartUri" target="_blank">
          <v-btn color="accent" flat round absolute right @click="openRicambiFg" :loading="sendingToShop">
            {{ $t('magazzino.label.vai_a_ricambifg') }}
            <v-icon class="ml-2">arrow_forward</v-icon>
          </v-btn>
          <input type="hidden" name="array" :value="filteredItemsForShop"/>
        </form>
      </template>

      <products-data-table :headers="[{text: $t('prodotti.label.nome'), value: 'name', sortable: true, width: 55},
                                      {text: $t('prodotti.label.prezzo'), value: 'price', sortable: true, width: 15, right: true},
                                      {text: $t('prodotti.label.quantita'), value: 'quantita', sortable: true, width: 20, right: true},
                                      {text: '', value: 'removable', width: 10, right: true}]"
                           :prodotti="items"
                           @click:remove="(item, index) => { items.splice(index, 1) }"
                           width-auto :no-data-text="$t('magazzino.messaggi.seleziona_prodotto_lista')">

        <template slot="footer" v-if="items.length > 0">
          <tr class="accent--text">
            <td>{{ $t('label.totale') }}:</td>
            <td class="text-xs-right">{{ totalPrice }}€</td>
            <td colspan="2">
              <v-tooltip bottom>
                <v-btn slot="activator" color="accent" class="right" icon small flat @click.stop="clearCart">
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>{{ $t('magazzino.azioni.svuota_carrello') }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </products-data-table>

      <v-btn slot="btn-confirm" slot-scope="{ validateFunction }" v-if="!$store.getters.isAbbonamentoExpired"
             color="accent" @click="validateFunction" :disabled="items.length === 0"
             :loading="sendingToMagazzino">
        {{$t('magazzino.azioni.aggiungi_magazzino') }}
      </v-btn>

    </form-dialog>
  </main>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import FormDialog from '@/components/base/FormDialog'
import ProductsDataTable from '@/components/ProductsDataTable'

export default {
    name: 'CartDialog',
    mixins: [Toggleable],
    components: { ProductsDataTable, FormDialog },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        sendingToMagazzino: false,
        sendingToShop: false,
        fgShopAddToCartUri: "https://ricambifg.com"///process.env.VUE_APP_FG_SHOP_ADD_CART
    }),
    computed: {
        totalPrice () {
            return this.items.reduce((accum, item) => accum + (item.price * item.quantita), 0).toFixed(2)
        },
        filteredItemsForShop () {
            return JSON.stringify(this.items.map(({ id, quantita }) => ({ id, quantita })))
        }
    },
    methods: {
        show () {
            this.isActive = true
        },
        clearCart () {
            this.items.splice(0, this.items.length)
        },
        openRicambiFg () {
            this.sendingToShop = true
            this.$refs.shopLinkForm.submit()
            this.sendingToShop = false
        },
        onConfirm () {
            this.sendingToMagazzino = true
            this.$api.magazzino.addToLocal(this.items).then(response => {
                this.sendingToMagazzino = false
                this.isActive = false
                this.clearCart()
                this.$snackbar.show(this.$t('magazzino.messaggi.prodotti_aggiunti'), 'success')
                this.$emit('success')
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.sendingToMagazzino = false
                this.$emit('error')
            })
        }
    }
}
</script>s
